var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.467 9a8.533 8.533 0 1 1 17.066 0A8.533 8.533 0 0 1 .467 9m15.847 0A7.314 7.314 0 1 0 1.685 9a7.314 7.314 0 0 0 14.63 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.924 8.39a.61.61 0 0 1 .066 1.216l-.066.004H1.076a.61.61 0 0 1-.066-1.216l.066-.003z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.344 8.969A14.3 14.3 0 0 1 8.527.692a.61.61 0 0 1 .946 0 14.3 14.3 0 0 1 3.183 8.277v.063a14.3 14.3 0 0 1-3.183 8.276.61.61 0 0 1-.946 0 14.3 14.3 0 0 1-3.183-8.276zm3.67-6.87L9 2.079l-.167.239a13.07 13.07 0 0 0-2.271 6.714L6.564 9l.014.236a13.07 13.07 0 0 0 2.408 6.665l.014.02.168-.238a13.07 13.07 0 0 0 2.255-6.447L11.437 9l-.014-.236A13.07 13.07 0 0 0 9.015 2.1",
    clipRule: "evenodd"
  })));
};
export default SvgGlobe;